import React, { ReactNode, useState } from 'react';
import { OverlayTrigger } from 'react-bootstrap';
import styled from 'styled-components';


type Props = {
    placement?: 'top' | 'right' | 'bottom' | 'left';
    buttonColor?: string;
    description: ReactNode | string;
    idKey: string;
};

const Tooltip = (props: Props) => {

    const [hoverShowFlg, setHoverShowFlg] = useState(false);
    const overlayTriggerIdName = 'overlay-trigger' + props.idKey;
    const description = typeof (props.description) == 'string' ? (props.description.split(/(\n)/).map((item, index) => {
        if (item && !item.match(/\n/)) {
            return (
                <React.Fragment key={index}>
                    <p style={{ margin: 0, padding: '3px 2px'}} >
                        {item}
                    </p>
                </React.Fragment>
            )
        } else {
            return null;
        }
    }))
        : props.description;

    return (
        <OverlayTrigger
            key={props.placement || 'right'}
            placement={props.placement || 'right'}
            show={hoverShowFlg}
            overlay={
                <CustomTooltipWithStyled>
                    <CustomTooltipContentsWithStyled>
                        {description}
                    </CustomTooltipContentsWithStyled>
                </CustomTooltipWithStyled>
            }
        >
            <CustomTooltipIconWithStyled className='customTooltip'>
                <i
                    onMouseEnter={() => setHoverShowFlg(true)}
                    onMouseLeave={() => setHoverShowFlg(false)}
                    id={overlayTriggerIdName}>
                    ?
                </i>
            </CustomTooltipIconWithStyled>
        </OverlayTrigger>
    )
}

const CustomTooltipIconWithStyled = styled.div`
    margin: 0 0 0 5px;
`
const CustomTooltipWithStyled = styled.div`
    background-color: transparent;
    padding: 5px;
    position: fixed;
    z-index: 9000;
`
const CustomTooltipContentsWithStyled = styled.div`
    background-color: rgba(10, 10, 10, 0.7);
    border-radius: 3px;
    color: white;
    padding: 10px;
    font-size: 14px;
    vertical-align: middle;
    max-width: 350px;
`

export default Tooltip;